// Lecture des réponses des API TURPE (moteur Python /api/v3, /api/v4 et backend
// Node /api/turpe). Bug 23/10/2026 : le toast affichait le corps JSON brut tronqué
// à 200 caractères, et les sauvegardes des résultats n'étaient jamais vérifiées
// (une sauvegarde en échec passait pour « Analyse terminée »).

/**
 * Message lisible d'un corps d'erreur : champ `error`, `detail` ou `message`
 * du JSON, sinon le texte brut.
 */
export function messageErreurApi(texte, statut) {
  let message = '';
  try {
    const corps = JSON.parse(texte);
    const brut = corps?.error ?? corps?.detail ?? corps?.message;
    message = typeof brut === 'string' ? brut : (brut ? JSON.stringify(brut) : '');
  } catch {
    message = (texte || '').trim();
  }
  return message ? `${message} (HTTP ${statut})` : `HTTP ${statut}`;
}

/**
 * Lit une réponse fetch et lève une erreur explicite si elle a échoué
 * (statut HTTP ou `success: false`). Renvoie le JSON (ou null si vide).
 */
export async function lireReponseApi(reponse, etape) {
  const texte = await reponse.text();
  if (!reponse.ok) {
    throw new Error(`${etape} : ${messageErreurApi(texte, reponse.status)}`);
  }
  if (!texte) return null;
  let corps;
  try {
    corps = JSON.parse(texte);
  } catch {
    throw new Error(`${etape} : réponse illisible (HTTP ${reponse.status})`);
  }
  if (corps && corps.success === false) {
    const raison = corps.message || corps.error || corps.details || 'échec sans motif';
    throw new Error(`${etape} : ${typeof raison === 'string' ? raison : JSON.stringify(raison)}`);
  }
  return corps;
}
